import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloClient} from 'apollo-client';
import {createHttpLink} from 'apollo-link-http';
import {ApolloLink, from} from 'apollo-link';
import {DefaultOptions} from 'apollo-client/ApolloClient';
import auth from '../../utils/auth';

const cache = new InMemoryCache();

const link = createHttpLink({
  // uri: 'https://api.graph.cool/simple/v1/cj7yfwulp1j710168atkx0492/api'
  uri: process.env.API_URL
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers

  if (localStorage.getItem('id_token')) {
    operation.setContext({
      headers: {
        authorization: `Bearer ${auth.getAccessToken()}`
      }
    });
  }
  return forward(operation);
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore'
  }
};

const client = new ApolloClient({
  cache,
  defaultOptions,
  connectToDevTools: true,
  link: from([authMiddleware, link])
});

export default client;



// WEBPACK FOOTER //
// ./src/api/graphql/client.ts